import {
  FormControl,
  MenuItem,
  Select,
  TableCell,
  Typography,
} from '@mui/material';
import useAppStore from 'store/useAppStore';
import { memo, useMemo } from 'react';

const DeviceSelect = ({ index }) => {
  const device = useAppStore((state) => state.scripts[index]['移動設備']);
  const materialDevices = useAppStore((state) => state.materialDevices);
  const setter = useAppStore((state) => state.setter);
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);

  const selectedDevice = useMemo(() => {
    if (device.id === 'NotFound') {
      return device.content;
    }
    if (!device.id) {
      return '';
    }
    console.log('device.id =', device.id)
    console.log('materialDevices =', materialDevices)
    //return materialDevices.find(({ id }) => id === device.id)['項目'];
    return materialDevices.find(({ id }) => id === device.id)?.['項目'];
  }, [device, materialDevices]);
  if (readOnly) {
    return (
      <TableCell sx={{ p: 1 }}>
        <Typography>{selectedDevice}</Typography>
      </TableCell>
    );
  }
  return (
    <TableCell sx={{ p: 1 }}>
      <FormControl fullWidth size="small">
        <Select
          value={device.id || ''}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const device = materialDevices.find(
              (device) => device.id === selectedValue,
            );
            setter('scripts', (draft) => {
              draft[index]['移動設備'] = {
                id: selectedValue,
                content: device['項目'],
              };
            });
          }}
          displayEmpty
          renderValue={
            device.id
              ? undefined
              : () => {
                return <span style={{ color: '#999' }}>選擇移動設備</span>;
              }
          }
        >
          {device.id === 'NotFound' && (
            <MenuItem key={device.id} value={device.id}>
              {device.content}
            </MenuItem>
          )}
          {materialDevices.map((device) => (
            <MenuItem key={device.id} value={device.id}>
              {device['項目']} - {device['類別']}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </TableCell>
  );
};
export default memo(DeviceSelect);
